import React from 'react';
import clsx from 'clsx';
import { LayoutProp } from 'types/Content';
import css from './ShadowBox.module.scss';

export default function ShadowBox(props: LayoutProp) {
  return (
    <div
      onClick={props.onClick}
      className={clsx([css.shadowBox], {[css.clickable]: !!props.onClick})}
      style={props.style}>
        {props.children}
    </div>
  );
}
